const WorkGroupIndex = () => import("@/pages/lab/workgroup/WorkGroupIndex");
const WorkGroupDetail = () =>
  import("@/pages/lab/workgroup/WorkGroupDetail");
const WorkGroupAdd = () => import("@/pages/lab/workgroup/WorkGroupAdd");
const WorkGroupEdit = () => import("@/pages/lab/workgroup/WorkGroupEdit");
const WorkGroupSingle = () =>
  import("@/pages/lab/workgroup/WorkGroupSingle");

export class WorkGroupRoutes {
  constructor() {
    this.route_root = "workgroups";
    this.type_single = "Work Group";
    this.type_plural = "Work Groups";

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            name: `List ${this.type_plural}`,
            component: WorkGroupIndex,
            meta: { requiresAuth: true },
          },
          {
            path: "add",
            name: `Add ${this.type_single}`,
            component: WorkGroupAdd,
            meta: { requiresAuth: true },
          },
          {
            path: ":work_group_id",
            component: WorkGroupSingle,
            children: [
              {
                path: "",
                name: `View ${this.type_single}`,
                component: WorkGroupDetail,
                meta: { requiresAuth: true },
              },
              {
                path: "edit",
                name: `Update ${this.type_single}`,
                component: WorkGroupEdit,
                meta: { requiresAuth: true },
              },
            ],
          },
        ],
      },
    ];
  }
  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }
  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
